import React from 'react';

const MessageInput = ({
  mode,
  inputValue,
  setInputValue,
  isLoading,
  files,
  handleFileSelect,
  handleSendMessage,
  handleKeyDown,
  handleInputChange,
  textareaRef,
  ttsLanguage,
  setTtsLanguage,
  ttsVoice,
  setTtsVoice,
  ttsEngine,
  setTtsEngine
}) => {
  return (
    <div className="input-container">
      <div className="input-wrapper">
        {(mode === 'chat' || mode === 'img2txt') && (
          <div className="input-actions">
            <label htmlFor="file-upload" className="upload-btn" title="Upload file or image">
              <span className="upload-icon">📎</span>
              <span className="upload-text">Attach</span>
              <input
                id="file-upload"
                type="file"
                multiple
                accept={mode === 'img2txt' ? "image/*" : "image/*,.txt,.pdf,.doc,.docx,.csv,.json,.xml,.html,.css,.js,.py,.java,.cpp,.c,.php,.rb,.go,.rs,.swift,.kt,.scala,.sh,.bat,.md,.rtf"}
                onChange={handleFileSelect}
              />
            </label>
            {files.length > 0 && (
              <div className="file-indicator">
                <div className="file-names">
                  {files.map((file, index) => (
                    <span key={index} className="file-name">
                      {file.name}
                      {index < files.length - 1 ? ', ' : ''}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {mode === 'txt2speech' && (
          <div className="tts-controls">
            <div className="tts-selectors">
              <select
                value={ttsLanguage}
                onChange={(e) => setTtsLanguage(e.target.value)}
                className="tts-select"
                title="Select language for text-to-speech"
              >
                <option value="en-US">🇺🇸 English (US)</option>
                <option value="en-GB">🇬🇧 English (UK)</option>
                <option value="es-ES">🇪🇸 Spanish</option>
                <option value="fr-FR">🇫🇷 French</option>
                <option value="de-DE">🇩🇪 German</option>
                <option value="it-IT">🇮🇹 Italian</option>
                <option value="pt-PT">🇵🇹 Portuguese</option>
                <option value="ru-RU">🇷🇺 Russian</option>
                <option value="ja-JP">🇯🇵 Japanese</option>
                <option value="ko-KR">🇰🇷 Korean</option>
                <option value="zh-CN">🇨🇳 Chinese (Mandarin)</option>
                <option value="ar-SA">🇸🇦 Arabic</option>
                <option value="hi-IN">🇮🇳 Hindi</option>
              </select>

              <select
                value={ttsVoice}
                onChange={(e) => setTtsVoice(e.target.value)}
                className="tts-select"
                title="Select voice for text-to-speech"
              >
                <option value="Joanna">Joanna (Female)</option>
                <option value="Matthew">Matthew (Male)</option>
                <option value="Amy">Amy (Female)</option>
                <option value="Brian">Brian (Male)</option>
                <option value="Emma">Emma (Female)</option>
                <option value="Raveena">Raveena (Female)</option>
                <option value="Ivy">Ivy (Female)</option>
                <option value="Justin">Justin (Male)</option>
                <option value="Kendra">Kendra (Female)</option>
                <option value="Kimberly">Kimberly (Female)</option>
                <option value="Salli">Salli (Female)</option>
                <option value="Joey">Joey (Male)</option>
                <option value="Nicole">Nicole (Female)</option>
                <option value="Russell">Russell (Male)</option>
              </select>

              <select
                value={ttsEngine}
                onChange={(e) => setTtsEngine(e.target.value)}
                className="tts-select"
                title="Select TTS engine"
              >
                <option value="standard">Standard</option>
                <option value="neural">Neural</option>
              </select>
            </div>
          </div>
        )}
        <textarea
          ref={textareaRef}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={
            mode === 'chat'
              ? "Message AGK Fire AI..."
              : mode === 'image'
                ? "Describe the image you want to generate..."
                : mode === 'img2txt'
                  ? "Enter image URL to analyze..."
                  : mode === 'txt2speech'
                    ? "Enter text to convert to speech..."
                    : mode === 'gpt4free-chat'
                      ? "Chat with GPT4Free..."
                      : mode === 'gpt4free-image'
                        ? "Describe the image you want GPT4Free to generate..."
                        : mode === 'gpt4free-audio'
                          ? "Enter text for GPT4Free audio generation..."
                          : "Enter your message..."
          }
          disabled={isLoading}
          rows={1}
        />
        <button
          className="send-button"
          onClick={handleSendMessage}
          disabled={isLoading || (inputValue.trim() === '' && files.length === 0)}
          title={
            mode === 'img2txt'
              ? "Analyze image"
              : mode === 'txt2speech'
                ? "Convert to speech"
                : mode === 'gpt4free-chat'
                  ? "Send to GPT4Free"
                  : mode === 'gpt4free-image'
                    ? "Generate with GPT4Free"
                    : mode === 'gpt4free-audio'
                      ? "Generate audio with GPT4Free"
                      : "Send message"
          }
        >
          {mode === 'img2txt' ? '🔍' :
           mode === 'txt2speech' ? '🔊' :
           mode === 'gpt4free-chat' ? '🤖' :
           mode === 'gpt4free-image' ? '🎨' :
           mode === 'gpt4free-audio' ? '🎵' : '↑'}
        </button>
      </div>
    </div>
  );
};

export default MessageInput;